import React from "react";
import { Link } from "react-router-dom";

import styles from "./users.module.css";
import Button from "../../../components/button/button";
import AddCircle from "../../../assets/icons/add-circle.svg";
import UserTable from "../../../components/user/userTable";
import BarsFilter from "../../../assets/icons/bars-filter.svg";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";

const Users = () => {
  return (
    <div>
      <HeaderTitle title="Usuários">
        <div className={styles.headerTitleActions}>
          <Button
            icon={BarsFilter}
            text="Filtrar"
            size="normal"
            variation="outline"
            disabled={true}
          />

          <Link to="/app/usuarios/register">
            <Button
              icon={AddCircle}
              text="Adicionar usuário"
              size="normal"
              variation="primary"
            />
          </Link>
        </div>
      </HeaderTitle>

      <div className="mainContentSpace">
        <UserTable />
      </div>
    </div>
  );
};

export default Users;
